<template>
  <layout>
    <div slot="content">
      <i-card :title="this.$route.meta.title">
        <div slot="content">
          <div>
            <el-form :inline="true" size="small" style="text-align: right">
              <el-form-item>
                <el-input placeholder="订单号" v-model="filter.uuid"></el-input>
              </el-form-item>
              <el-form-item>
                <el-input v-model="filter.linker_mobile" placeholder="联系人手机号"></el-input>
              </el-form-item>
              <el-form-item>
                <el-input v-model="filter.title" placeholder="商品名称"></el-input>
              </el-form-item>
              <el-form-item>
                <el-input v-model="filter.linker_name" placeholder="联系人姓名"></el-input>
              </el-form-item>
              <el-form-item>
                <el-date-picker v-model="filter.use_date" style="width: 175px" value-format="yyyy-MM-dd" type="date"
                                placeholder="出行日期" clearable></el-date-picker>
              </el-form-item>
              <el-form-item>
                <el-select placeholder="退款状态" style="width: 175px" v-model="filter.pay_status">
                  <el-option label="退款中" value="2"></el-option>
                  <el-option label="已退款" value="3"></el-option>
                  <el-option label="退款失败" value="4"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="getOrder(1)">查找</el-button>
                <el-button type="primary" @click="reset">重置</el-button>
              </el-form-item>
            </el-form>
          </div>
          <div style="overflow-x: auto;padding-bottom: 20px;" v-loading="loading">
            <div class="no-data" v-if="orderList.length <= 0">暂无退款订单</div>
            <div class="table-card" v-for="item in orderList">
              <div class="order-info" :style="item.people.length > 0?'border-bottom:0':''">
                <div class="order-item" style="width: 100%">
                  商品名称:{{ item.title }}(<strong>{{ item.goods_type }}</strong>)
                </div>
                <div class="order-item" style="width: 100%;color: red">
                  退款原因:{{ item.refund.reason }}
                </div>
                <div class="order-item">
                  航班号:{{ item.ship ? item.ship.sailings_code : '该订单无航班' }}
                </div>
                <div class="order-item">
                  联系人:{{ item.linker_name }}
                </div>
                <div class="order-item">
                  联系人手机:{{ item.linker_mobile }}
                </div>
                <div class="order-item">
                  出行日期:{{ item.use_date }}
                </div>
                <div class="order-item">
                  订单号:{{ item.uuid }}
                </div>
                <div class="order-item">
                  下单时间:{{ item.created_at }}
                </div>
                <div class="order-item">
                  购买数量:{{ item.goods_count }}张
                </div>
                <div class="order-item">
                  申请时间:{{ item.refund.created_at }}
                </div>
                <div class="order-item">
                  支付金额:{{ item.pay_total }}元
                </div>
                <div class="order-item">
                  申请退款金额:{{ item.refund.total }}元
                </div>
                <div class="order-item">
                  退款手续费:{{ item.refund.refund_fee }} *{{ item.goods_count }}张
                </div>
                <div class="order-item">
                  实际退款金额:{{ item.refund.refund_total }}元
                </div>
                <div class="order-item">
                  支付商户:{{ item.mch_name }} ({{ item.mch_id }})
                </div>
                <div class="order-item">
                  退款状态:
                  <el-tag size="mini" :type="item.pay_status === 2?'danger':'warning'">
                    {{ item.pay_status_name }}
                  </el-tag>
                </div>
                <div class="order-item">
                  出票状态:
                  <el-tag size="mini" :type="item.check_status === 2?'success':'danger'">
                    {{ item.check_status_name }}
                  </el-tag>
                </div>
                <div class="order-item">
                  处理状态:
                  <el-tag size="mini" :type="item.resolve_status === 1?'success':'danger'">
                    {{ item.resolve_status_name }}
                  </el-tag>
                </div>
                <div class="order-item" style="width:100%;text-align: right;padding: 10px;">
                  <router-link :to="{name:'order.detail',query:{uuid:item.uuid}}">
                    <el-button size="mini" type="primary">详情/编辑</el-button>
                  </router-link>
                  <el-button size="mini" type="success" @click="showPassConfirm(item.refund,item)">确定退款</el-button>
                  <el-button size="mini" type="danger" @click="showRefuseConfirm(item.refund)">拒绝退款</el-button>
                </div>
              </div>
              <table class="table">
                <tr v-for="people in item.people">
                  <td>{{ people.name }}</td>
                  <td>{{ people.cert_no }}</td>
                  <td>{{ people.cert_type }}</td>
                  <td width="25%">备注:
                    <el-input style="width: 80%" v-model="people.remark" size="mini" placeholder="请输入备注"
                              @blur="addRemark(people.id,people.remark)"></el-input>
                  </td>
                </tr>
              </table>
            </div>
          </div>
          <div class="page-wrap">
            <el-pagination background :current-page="pageInfo.current_page" layout="prev, pager, next"
                           :page-size="15"
                           @current-change="changePage" :total="pageInfo.total"></el-pagination>
          </div>
        </div>
      </i-card>
      <!--通过审核-->
      <el-dialog title="通过退款申请？" :visible.sync="showPass" width="30%">
        <div>
          <el-form>
            <el-form-item label="退款金额" required>
              <el-input v-model="refund.refund_total" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="备注">
              <el-input v-model="refund.remark" autocomplete="off"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="showPass = false">取 消</el-button>
          <el-button type="primary" @click="doPass" :loading="passLoading">确 定</el-button>
        </div>
      </el-dialog>
      <!--拒绝-->
      <el-dialog title="拒绝退款申请？" :visible.sync="showRefuse" width="30%">
        <div>
          <el-form>
            <el-form-item label="退款金额" required>
              <el-input v-model="refund.refund_total" autocomplete="off" disabled></el-input>
            </el-form-item>
            <el-form-item label="备注" required>
              <el-input v-model="refund.remark" autocomplete="off"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="showRefuse = false">取 消</el-button>
          <el-button type="primary" @click="doRefuse" :loading="passLoading">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </layout>
</template>

<script>
export default {
  name: "order-list",
  data() {
    return {
      orderList: [],
      filter: {
        linker_mobile: '',
        linker_name: '',
        pay_status: '',
        uuid: '',
        use_date: '',
      },
      loading: false,
      showPass: false,
      showRefuse: false,
      passLoading: false,
      pageInfo: {
        current_page: 1,
        total: 0,
      },
      refund: {
        refund_id: '',
        refund_total: '',
        refund_fee: '',
        remark: '',
      },
      order:{}
    }
  },
  methods: {
    getOrder: function (page = '') {
      this.loading = true;
      if (page) {
        this.pageInfo.current_page = page;
      }
      this.$http.request('refundList', {
        filter: this.filter,
        page: this.pageInfo.current_page
      }).then(res => {
        this.orderList = res.data;
        this.loading = false;
        this.pageInfo = res.meta;
        window.scrollTo(0, 0)
      });
    },
    changePage: function (page) {
      this.pageInfo.current_page = page;
      this.getOrder();
    },
    reset: function () {
      for (let i in this.filter) {
        if (i !== 'goods_type') {
          this.filter[i] = '';
        }
      }
      this.getOrder();
    },
    addRemark: function (id, remark) {
      this.$http.request('addPeopleRemark', {id: id, remark: remark}).then(res => {
        this.$notify({
          title: '成功',
          message: res.message,
          type: res.status,
          duration: 2000
        });
      });
    },
    showPassConfirm: function (refund,order) {
      this.refund.refund_id = refund.refund_id;
      this.refund.refund_total = refund.total;
      this.refund.refund_fee = refund.refund_fee;
      this.refund.remark = refund.remark;
      this.order = order;
      this.showPass = true;
    },
    showRefuseConfirm: function (refund) {
      this.refund.refund_id = refund.refund_id;
      this.refund.refund_total = refund.total;
      this.refund.remark = refund.remark;
      this.showRefuse = true;
    },
    doPass: function () {
      this.passLoading = true;
      let _self = this;
      this.$http.request('passRefund', this.refund).then(res => {
        this.passLoading = false;
        if (res.status === 'success') {
          _self.$message({
            message: res.message,
            type: 'success',
            onClose: function () {
              _self.showPass = false;
              _self.getOrder();
            }
          });
        }
      })
    },
    doRefuse: function () {
      this.passLoading = true;
      let _self = this;
      this.$http.request('refuseRefund', this.refund).then(res => {
        this.passLoading = false;
        if (res.status === 'success') {
          _self.$message({
            message: res.message,
            type: 'success',
            onClose: function () {
              _self.showRefuse = false;
              _self.getOrder();
            }
          });
        }
      })
    }
  },
  created: function () {
    this.getOrder();
  },
}
</script>

<style scoped>

.table-card {
  width: 100%;
  font-size: 12px;
  margin-top: 30px;
}

.table-card .order-info {
  background: #f9f9f9;
  overflow: hidden;
  border: 1px solid #dcdcdc;
}

.table-card .order-info .order-item {
  float: left;
  width: 25%;
  padding: 5px 10px;
  box-sizing: border-box;
}

.table {
  width: 100%;
  border-collapse: collapse;
}

.table tr:hover {
  background: #eee;
}

.table td {
  border: 1px solid #dcdcdc;
  padding: 10px;
}

.no-data {
  text-align: center;
  font-size: 14px;
  font-weight: bold;
  margin-top: 30px;
}
</style>



// WEBPACK FOOTER //
// src/pages/order/refund-list.vue